/**
 *
 * Copyright(c) 2024 Magrabi.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Magrabi ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Magrabi.
 *
 *
 * @author Sivaprasad
 *
 */
import { FC } from "react";
import { IconProps } from "@/common/lib/types";

const Icon: FC<IconProps> = (props) => {
  return (
    <svg {...props} width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 0C5.879 0.00238211 3.84555 0.846002 2.34578 2.34578C0.846002 3.84555 0.00238211 5.879 0 8C0 13.6367 7.07044 20.772 7.37144 21.073C7.53925 21.2376 7.76493 21.3298 8 21.3298C8.23507 21.3298 8.46075 21.2376 8.62856 21.073C8.92955 20.772 16 13.6367 16 8C15.9976 5.879 15.154 3.84555 13.6542 2.34578C12.1544 0.846002 10.121 0.00238211 8 0ZM8 19.1518C6.30633 17.3086 1.77778 12.005 1.77778 8C1.77778 6.34976 2.43333 4.76712 3.60022 3.60022C4.76712 2.43333 6.34976 1.77778 8 1.77778C9.65024 1.77778 11.2329 2.43333 12.3998 3.60022C13.5667 4.76712 14.2222 6.34976 14.2222 8C14.2222 12.005 9.69356 17.3087 8 19.1518Z"
        fill="black"
      />
      <path d="M11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8Z" fill="black" />
    </svg>
  );
};

export default Icon;
